import React from "react";

/** A small trend line, oldest left, with the latest point marked. Two or more points. */
const Sparkline = ({ points, className = "text-foreground", height = 28 }) => {
  if (!points || points.length < 2) return null;
  const W = 120;
  const values = points.map((p) => p.value);
  const lo = Math.min(...values);
  const hi = Math.max(...values);
  const x = (i) => 2 + (i / (points.length - 1)) * (W - 4);
  const y = (v) => height - 3 - ((v - lo) / (hi - lo || 1)) * (height - 6);
  const d = values.map((v, i) => `${i ? "L" : "M"}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join("");
  return (
    <svg
      viewBox={`0 0 ${W} ${height}`}
      preserveAspectRatio="none"
      className={`block w-full ${className}`}
      style={{ height }}
      aria-hidden="true"
    >
      <path d={d} fill="none" stroke="currentColor" strokeWidth="1.75" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export default Sparkline;
